import React, { DetailedHTMLProps, HTMLAttributes } from "react";
function Button(props: ButtonProps) {
  const { children, onClick, buttonStyle, disabled, ...rest } = props;
  return (
    <button
      {...rest}
      disabled={disabled}
      type="button"
      onClick={onClick}
      className={`${buttonStyle}`}
    >
      {children}
    </button>
  );
}

export default Button;

Button.defaultProps = {};

interface ButtonProps extends DetailedHTMLProps<HTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  onClick: (evt: React.MouseEvent<HTMLButtonElement>) => void;
  buttonStyle?: string;
  disabled?: boolean;
}
